<template>
  <div id="cash-add-document" class="mt-5">
    <b-container fluid class="bv-example-row">
      <b-row class="p-1" align-h="end">
        <b-col cols="auto">
          <b-button variant="success" @click="addDocumentHandler">
            {{ viewType }}
          </b-button>
        </b-col>
      </b-row>
      <b-row class="p-2">
        <b-col>
          เลขที่เอกสาร
        </b-col>
        <b-col>
          <b-form-input v-model="inInputComputed" size="sm" />
        </b-col>
        <b-col>
          วันที่ออกเอกสาร
        </b-col>
        <b-col>
          <datepicker v-model="inDateComputed" />
        </b-col>
        <template v-if="isDocumentHasTax()">
          <b-col>
            เลขที่ใบกำกับ
          </b-col>
          <b-col>
            <b-form-input v-model="tiInputComputed" size="sm" />
          </b-col>
          <b-col>
            วันที่ออกใบกำกับ
          </b-col>
          <b-col>
            <datepicker v-model="tiDateComputed" />
          </b-col>
        </template>
        <b-col>
          <b-row>
            <b-col class="col-auto">
              ค่าขนส่ง
            </b-col>
            <b-col class="col-auto">
              <b-form-input
                v-model="toComputed"
                type="number"
                placeholder="ค่าขนส่ง"
                size="sm"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-lg-2 col-md-3 col-sm-12  pr-0">
          <search-hospital-cash-add-document-component
            :hospital-address.sync="hospitalAddress"
            :hospital-name.sync="hospitalName"
            :hospital-phone-number.sync="hospitalPhoneNumber"
            :hospital-input.sync="hospitalInputComputed"
            class="fixed-height"
          />
        </b-col>
        <b-col class="col-lg-10 col-md-9 col-sm-12 pl-0">
          <add-item-table-cash-add-document-component
            class="fixed-height table"
            :order-select-items.sync="orderSelectItemsInput"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SearchHospitalCashAddDocumentComponent from "./SearchHospitalCashAddDocumentComponent";
import AddItemTableCashAddDocumentComponent from "./AddItemTableCashAddDocumentComponent";
import Datepicker from "vuejs-datepicker";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CashDocumentComponent",
  components: {
    SearchHospitalCashAddDocumentComponent,
    AddItemTableCashAddDocumentComponent,
    Datepicker,
  },
  props: {
    hospitalInput: {
      required: true,
    },
    customHospitalInput: {
      type: Object,
    },
    orderSelectItems: {
      type: Array,
    },
    addDocumentHandler: {
      type: Function,
    },
    inInput: {
      required: true,
    },
    tiInput: {
      required: true,
    },
    inDate: {
      required: true,
    },
    tiDate: {
      required: true,
    },
    viewType: {
      default: "สร้างเอกสาร",
    },
    toInput: {
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      documentTypes: "Account/getFilterDocumentType",
      hospital: "Hospital/getAll",
    }),
    inInputComputed: {
      get() {
        return this.inInput;
      },
      set(val) {
        this.$emit("update:inInput", val);
      },
    },
    tiInputComputed: {
      get() {
        return this.tiInput;
      },
      set(val) {
        this.$emit("update:tiInput", val);
      },
    },
    inDateComputed: {
      get() {
        return this.inDate;
      },
      set(val) {
        this.$emit("update:inDate", val);
      },
    },
    tiDateComputed: {
      get() {
        return this.tiDate;
      },
      set(val) {
        this.$emit("update:tiDate", val);
      },
    },
    toComputed: {
      get() {
        return this.toInput;
      },
      set(val) {
        this.$emit("update:toInput", val);
      },
    },
    orderSelectItemsInput: {
      get() {
        return this.orderSelectItems;
      },
      set(val) {
        this.$emit("update:orderSelectItems", val);
      },
    },
    hospitalInputComputed: {
      get() {
        if (!this.hospitalInput) {
          return this.hospitalInput;
        }
        if (typeof this.hospitalInput === "number") {
          let hospitalSelected = this.hospital.find(
            (e) => e.id === this.hospitalInput
          );
          // eslint-disable-next-line vue/no-async-in-computed-properties
          this.searchHospitalName({
            name: hospitalSelected.name,
          }).then((result) => {
            this.$emit("update:customHospitalInput", {
              hospitalName: result.name,
              hospitalAddress: result.fullAddress,
              hospitalPhoneNumber: result.phone,
            });
          });
          return hospitalSelected;
        }
        let hospitalSelected = this.hospital.find(
          (e) => e.id === this.hospitalInput.id
        );
        // eslint-disable-next-line vue/no-async-in-computed-properties
        this.searchHospitalName({
          name: hospitalSelected.name,
        }).then((result) => {
          this.$emit("update:customHospitalInput", {
            hospitalName: result.name,
            hospitalAddress: result.fullAddress,
            hospitalPhoneNumber: result.phone,
          });
        });
        return this.hospitalInput;
      },
      async set(val) {
        this.$emit("update:hospitalInput", val);

        if (val !== "") {
          let result = await this.searchHospitalName({
            name: val.name,
          });

          if (result) {
            this.$emit("update:customHospitalInput", {
              hospitalName: result.name,
              hospitalAddress: result.fullAddress,
              hospitalPhoneNumber: result.phone,
            });
          }
        }
      },
    },
    hospitalName: {
      get() {
        return this.customHospitalInput.hospitalName;
      },
      set(val) {
        this.$emit("update:customHospitalInput", {
          hospitalName: val,
          hospitalAddress: this.hospitalAddress,
          hospitalPhoneNumber: this.hospitalPhoneNumber,
        });

        if (this.orderSelectItemsInput.length > 0) {
          this.orderSelectItemsInput.map((e) => {
            e.hospital_name = val;
          });
        }
      },
    },
    hospitalAddress: {
      get() {
        return this.customHospitalInput.hospitalAddress;
      },
      set(val) {
        this.$emit("update:customHospitalInput", {
          hospitalName: this.hospitalName,
          hospitalAddress: val,
          hospitalPhoneNumber: this.hospitalPhoneNumber,
        });

        if (this.orderSelectItemsInput.length > 0) {
          this.orderSelectItemsInput.map((e) => {
            e.hospital_name = val;
          });
        }
      },
    },
    hospitalPhoneNumber: {
      get() {
        return this.customHospitalInput.hospitalPhoneNumber;
      },
      set(val) {
        this.$emit("update:customHospitalInput", {
          hospitalName: this.hospitalName,
          hospitalAddress: this.hospitalAddress,
          hospitalPhoneNumber: val,
        });

        if (this.orderSelectItemsInput.length > 0) {
          this.orderSelectItemsInput.map((e) => {
            e.hospital_name = this.hospitalName;
          });
        }
      },
    },
  },
  methods: {
    ...mapActions({
      searchHospitalName: "Hospital/searchHospitalName",
    }),
    isDocumentHasTax() {
      return !!this.documentTypes.find((documentType) => {
        return documentType.name === "ใบกำกับภาษี";
      });
    },
  },
  data() {
    return {
      canCreate: false,
      // orderSelectItemsInput: []
    };
  },
  watch: {
    hospitalName(newVal, oldVal) {},
    hospitalAddress(newVal, oldVal) {},
    hospitalPhoneNumber(newVal, oldVal) {},
    orderSelectItemsInput(newVal, oldVal) {
      newVal.map((e) => {
        e.hospital_name = this.hospitalName;
      });
      this.orderSelectItemsInput = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.fixed-height {
  height: 500px;
  &.table {
    overflow-y: auto;
  }
}
</style>
